import { Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { CdkFixedSizeVirtualScroll, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Router, RouterLink } from '@angular/router';
import { AppStateService } from '../../../services/app-state.service';
import { ApiCmdService } from '../../../services/api-cmd.service';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { toObservable } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { DataListCompaniesApiResponseDto, QueryListCompaniesApiRequestDto } from '@packages/api-cmd-type-definitions';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, MatSortHeader, Sort } from '@angular/material/sort';
import { MatSidenavContent } from '@angular/material/sidenav';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CompaniesFiltersComponent } from '../filters/companies-filters.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';
import { HasRoleModule } from '../../../modules/has-role.module';
import { MatSnackBar } from '@angular/material/snack-bar';
import { handlerSnackbarApiError } from '../../../utils/snackbar.handler';

@Component({
  selector: 'app-aziende',
  standalone: true,
  imports: [
    MatSidenavContent,
    MatButton,
    RouterLink,
    MatTable,
    MatSort,
    MatHeaderCell,
    MatColumnDef,
    MatCell,
    MatHeaderRow,
    MatRow,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRowDef,
    MatRowDef,
    CdkVirtualScrollViewport,
    CdkFixedSizeVirtualScroll,
    MatSortHeader,
    MatIconButton,
    MatIcon,
    MatProgressSpinner,
    NgIf,
    HasRoleModule,
  ],
  templateUrl: './list-companies.component.html',
  styleUrl: './list-companies.component.scss',
})
export class ListCompaniesComponent implements OnInit, OnDestroy {
  public router = inject(Router);
  public appStateService = inject(AppStateService);
  private apiCmdService = inject(ApiCmdService);
  displayedColumns: string[] = ['name', 'vatNumber', 'website', 'countryIso2', 'agemCode', 'numberEmployees', 'sales'];
  dataSource = new MatTableDataSource<any>([]);
  paginationSkip = 0;
  paginationLimit = 32;
  sortField = 'name';
  sortDirection: 'asc' | 'desc' = 'asc';
  public $legalEntityCodeSelected = toObservable(computed(() => this.appStateService.$legalEntityCodeSelected())).subscribe({
    next: value => {
      this.clearTable();
      this.loadData();
    },
    error: err => {
      console.error(err);
    },
  });
  private scrollSubscription: Subscription = new Subscription();
  private queryFilters: QueryListCompaniesApiRequestDto = {};
  public isLoading = true;

  constructor(
    public dialog: MatDialog,
    private snackbar: MatSnackBar
  ) {}

  private setterIsLoading(value: boolean): () => void {
    return () => {
      this.isLoading = value;
    };
  }

  ngOnInit() {
    //this.loadData();
  }

  ngOnDestroy() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
    this.resetSort();
    this.clearTable();
  }

  refreshList() {
    this.clearTable();
    this.loadData();
  }

  openFilterDialog(): void {
    const dialogRef = this.dialog.open(CompaniesFiltersComponent, { data: this.queryFilters });

    dialogRef.componentInstance.filtersApplied.subscribe((filters: any) => {
      this.applyFilters(filters);
      if (Object.keys(filters).length > 0) {
        this.clearTable();
        this.loadData();
      }
    });
  }

  clearTable() {
    this.paginationSkip = 0;
    this.dataSource.data = [];
  }
  resetSort() {
    this.sortField = 'name';
    this.sortDirection = 'asc';
  }

  applyFilters(filters: Record<string, any>): void {
    Object.keys(filters).forEach(attribute => {
      if (filters[attribute] === null || filters[attribute] === undefined || filters[attribute] === '') {
        // @ts-expect-error TS7053
        delete this.queryFilters[attribute];
      } else {
        // @ts-expect-error TS7053
        this.queryFilters[attribute] = filters[attribute];
      }
    });
  }

  loadData() {
    this.isLoading = true;
    this.apiCmdService
      .listCompanies({
        ...this.queryFilters,
        paginationSkip: this.paginationSkip,
        paginationLimit: this.paginationLimit,
        sortOrder: this.sortDirection,
        fieldOrder: this.sortField,
      })
      .subscribe({
        next: (response: DataListCompaniesApiResponseDto) => {
          this.dataSource.data = [...this.dataSource.data, ...response.data];
          this.isLoading = false;
        },
        error: err => handlerSnackbarApiError(this.snackbar, err, [this.setterIsLoading(false)]),
      });
  }

  loadMoreData(event: any) {
    this.paginationSkip += this.paginationLimit;
    this.loadData();
  }

  sortData(sort: Sort) {
    this.sortField = sort.active;
    this.sortDirection = sort.direction || 'asc';
    this.clearTable();
    this.loadData();
  }

  onRowClick(event: MouseEvent, row: any) {
    if (window.getSelection()?.toString()) {
      return; // Do nothing if text is selected
    }

    this.router.navigate(['/aziende/view', row.id]);
  }

  onMouseUp(event: MouseEvent) {
    // This method is just to capture the mouseup event
  }
}
